var render = function render(){var _vm=this,_c=_vm._self._c;return _c('exception',{attrs:{"title":"404 Error!","description":"抱歉，你访问的页面不存在~"}})
}
var staticRenderFns = []

export { render, staticRenderFns }